import PaymentImportCreatePage from './PaymentImportCreatePage';

export default PaymentImportCreatePage;
